import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart/cart.service';
import { CategoryService } from 'src/app/services/category/category.service';
import { MatMenu } from '@angular/material/menu';
import { LoginComponent } from 'src/app/components/modals/login/login.component';
import { RegisterComponent } from 'src/app/components/modals/register/register.component';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
// TranslationService eliminado - usando OptimizedI18nService
import {
  faX,
  faTrash,
  faPlus,
  faCartShopping,
  faMinus,
  faAngleDown,
  faBell
} from '@fortawesome/free-solid-svg-icons';
import { faUser, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  cartOpen: boolean = false;
  faCartShopping = faCartShopping;
  faX = faX;
  faTrash = faTrash;
  faMinus = faMinus;
  faPlus = faPlus;
  faBell = faBell;
  faAngleDown = faAngleDown;
  faUser = faUserCircle;
  modalCarga?: NgbModalRef;
  cartItems: any[] = [];
  menuOpen: boolean = false;
  loading: boolean = false;
  error: string = '';
  categoriesOpen: boolean = false;
  totalItems: number = 0;
  totalAmount: number = 0;
  categories: any[] = [];
  isLoading: boolean = false;
  subMenus: { [key: string]: MatMenu } = {};
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  @ViewChildren('menuRef') menuRefs!: QueryList<MatMenu>;

  isLoggedIn: boolean = false;
  userName: string = '';
  altoReindimiento = [
    { name: 'Entrenamiento', _id: '67d48a874a3c980057c3cb0f' },
    { name: 'Competencia', _id: '67d48a874a3c980057c3cb9e' },
    { name: 'Recuperación', _id: '67d48a874a3c980057c3cb9f' },
  ];
  listServicios = [
    {
      name: 'Med-Veterinarios/ Especialidades',
      _id: '67da3495df85cc4e48522025',
    },
    { name: 'Asociaciones', _id: '67da3495df85cc4e48522021' },
    { name: 'Clases Disciplinas Ecuestres', _id: '67da3495df85cc4e48522020' },
    { name: 'Manejo Caballos', _id: '67da3495df85cc4e48522022' },
    { name: 'Instituciones Académicas', _id: '67da3495df85cc4e48522024' },
    { name: 'Otros', _id: '67da3495df85cc4e48522023' },
  ];

  notificationsOpen = false;
  notifications: any[] = [];
  unreadNotificationsCount = 0;
  currentLanguage: string = 'es';
  mockNotifications = [
    {
      "_id": "681df645d7f98781a4e50308",
      "destination": "681a803c3a96dbaec1f87f73",
      "userId": "680d3be22085bbe9dbf675ec",
      "notification": "Alguien valoró tu opinión sobre: Hotel Aldea Valle Encantado",
      "origin": "like",
      "createdAt": "2025-05-09T12:34:13.532Z",
      "read": false,
      "__v": 0
    },
    {
      "_id": "681df644d7f98781a4e50301",
      "destination": "681a803c3a96dbaec1f87f73",
      "userId": "680d3be22085bbe9dbf675ec",
      "notification": "Alguien valoró tu opinión sobre: Hotel Aldea Valle Encantado",
      "origin": "like",
      "createdAt": "2025-05-09T12:34:12.283Z",
      "read": false,
      "__v": 0
    },
    {
      "_id": "681df641d7f98781a4e502fa",
      "destination": "681a803c3a96dbaec1f87f73",
      "userId": "680d3be22085bbe9dbf675ec",
      "notification": "Alguien valoró tu opinión sobre: Hotel Aldea Valle Encantado",
      "origin": "like",
      "createdAt": "2025-05-09T12:34:09.241Z",
      "read": true,
      "__v": 0
    }
  ];

  private OTHER_WORDS_ES = ['otros', 'otras'];
  private loginSubscription: Subscription | undefined;

  constructor(
    private categoryService: CategoryService,
    private cartService: CartService,
    private router: Router,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    // private translationService: TranslationService - eliminado
  ) { }

  ngOnInit(): void {
    this.loginSubscription = this.authService.loginSuccess$.subscribe(() => {
      this.updateHeader();
    });
    this.cartService.totalItems$.subscribe((count) => {
      this.totalItems = count;
    });

    // Inicializar idioma
    const savedLang = localStorage.getItem('selectedLanguage') || 'es';
    this.currentLanguage = savedLang;
    
    // Inicializar estado del selector después de un pequeño delay
    setTimeout(() => {
      this.changeLanguage(savedLang);
    }, 100);

    this.checkLoginStatus();
  }

  toggleNotifications() {
    this.notificationsOpen = !this.notificationsOpen;
    if (this.notificationsOpen && this.unreadNotificationsCount > 0) {
      this.markNotificationsAsRead();
    }
  }

  closeNotifications() {
    this.notificationsOpen = false;
  }

  loadNotifications() {
    this.authService.getNotifications().subscribe({
      next: (response) => {
        if (response.success) {
          // Mantenemos el valor 'read' que viene del backend o false si no existe
          this.notifications = response.data;

          // Contamos solo las que tienen read: false
          this.unreadNotificationsCount = this.notifications.filter(n => n.read === false).length;
        }
      },
      error: (error) => {
        console.error('Error al cargar notificaciones:', error);
        this.notifications = [];
        this.unreadNotificationsCount = 0;
      }
    });
  }

  markNotificationsAsRead() {
    // this.authService.m().subscribe({
    //   next: () => {
    //     // Marcamos como leídas localmente
    //     this.unreadNotificationsCount = 0;
    //   },
    //   error: (error) => {
    //     console.error('Error al marcar notificaciones como leídas:', error);
    //     // Podemos marcarlas como leídas localmente aunque falle en el backend
    //     this.unreadNotificationsCount = 0;
    //   }
    // });
  }


  updateHeader(): void {
    this.checkLoginStatus();
  }

  ngAfterViewInit(): void {

  }

  checkLoginStatus(): void {
    const userData = this.authService.getUserData();
    if (userData) {
      this.isLoggedIn = true;
      this.userName = userData.data_user.name;
      this.loadNotifications();
    } else {
      this.isLoggedIn = false;
      this.userName = '';
    }
    this.cdr.detectChanges();
  }

  goModule(): void {
    this.router.navigate(['/user'], { queryParams: { redirect: 'profile' } });
  }

  toggleCart(): void {
    this.cartOpen = !this.cartOpen;
  }
  toggleSubcategories(category: any): void {
    category.subcategoriesOpen = !category.subcategoriesOpen;
  }
  goProductCat(cat: any, subCar: any): void {
    this.router.navigate([`/home/detail-category/${cat}`], {
      queryParams: { subcat: subCar },
    });
  }
  login() {
    this.modalCarga = this.modalService.open(
      LoginComponent,
      this.ngbModalOptions
    );
    this.modalCarga.result.then(
      () => {
        this.checkLoginStatus();
      },
      () => {
        this.checkLoginStatus();
      }
    );
  }

  register() {
    this.modalCarga = this.modalService.open(
      RegisterComponent,
      this.ngbModalOptions
    );
    this.modalCarga.result.then(
      () => {
        this.checkLoginStatus();
      },
      () => {
        this.checkLoginStatus();
      }
    );
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  sortSubcategories(category: any): void {
    if (category.subcatList && category.subcatList.length > 0) {
      category.subcatList.sort((a: any, b: any) => {
        if (!a || !b) return 0;
        const nameA = a.name?.toLowerCase();
        const nameB = b.name?.toLowerCase();
        if (this.OTHER_WORDS_ES.includes(nameA)) return 1;
        if (this.OTHER_WORDS_ES.includes(nameB)) return -1;
        return nameA?.localeCompare(nameB) || 0;
      });
    }
  }

  changeLanguage(languageCode: string): void {
    console.log('Idioma cambiado a:', languageCode);
    localStorage.setItem('selectedLanguage', languageCode);
    document.documentElement.lang = languageCode;
    
    // Actualizar UI del selector
    const btnEs = document.getElementById('btn-es');
    const btnEn = document.getElementById('btn-en');
    
    if (btnEs && btnEn) {
      btnEs.classList.remove('active');
      btnEn.classList.remove('active');
      
      if (languageCode === 'es') {
        btnEs.classList.add('active');
      } else {
        btnEn.classList.add('active');
      }
    }
    
    // Forzar detección de cambios
    this.cdr.detectChanges();
  }

}
